// #region CONSTANTES
export const RESSOURCE_CONTACT = "demande";
export const TYPE_DEMANDE_SERVICE = 0;
export const TYPE_DEMANDE_PROGICIEL = 1;
// #endregion